import React from 'react'
import styled from 'styled-components'

const TabContentTitle = ({ children }: { children: React.ReactNode }) => {
  return <S.Title>{children}</S.Title>
}

export default TabContentTitle

const S = {
  Title: styled.h2`
    text-transform: capitalize;
  `
}
